module.exports = __webpack_public_path__ + "font_malecharacter.f7a3e907.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/parent_to_child/font_malecharacter.png
// module id = 1MFH
// module chunks = 0